import script from "./SimilarGoods.vue?vue&type=script&lang=ts&setup=true"
export * from "./SimilarGoods.vue?vue&type=script&lang=ts&setup=true"

import "./SimilarGoods.vue?vue&type=style&index=0&id=2d8999e5&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d8999e5"]])

export default __exports__